import { useEffect } from 'react';
import { LastWebsocketJsonMessageType } from '@interfaces/webSocketConnectionInfo';
import { useMytaStreams } from './MytaStreamsProvider';

// The one websocket handler that reads a message whose session key is NOT the current one — on purpose, and only
// the classes seatMove.ts names (`moveEntryProof`, `movedWorldSignal`). During a packing move the second UE logs in
// under its own key; its TELEPORT_FINISHED is the proof the switch waits for, its socket coming up is when the layout
// is published to it, and its geometry report is held for the switch. Every other handler rightly skips them.
export const useHandleSeatMoveSessionMsg = (
  lastJsonMessage: LastWebsocketJsonMessageType,
) => {
  const { noteSessionEvent } = useMytaStreams();

  useEffect(() => {
    if (!lastJsonMessage?.action) {
      return;
    }
    noteSessionEvent(
      lastJsonMessage.action,
      lastJsonMessage.sessionKey,
      (lastJsonMessage as { payload?: unknown }).payload,
    );
  }, [lastJsonMessage, noteSessionEvent]);
};
